import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { showData } from "../../../service/Contrato/showData";
import { domain } from "../../../Urls/Services/Api_urls";
import { PolygonEdit } from "./PolygonEdit";

export const PolygonSearch = () => {
const { token } = window.sessionStorage;
const id = useParams();
const METOD0 = "GET";
const url = "/polygonsftth/" + id.id;
const [polygon, setpolygon] = useState([]);
const [polygonRender, setpolygonRender] = useState([]);
useEffect(() => {
    showData(METOD0, token, url)
    .then((resultinfo) => {
        setpolygon(resultinfo.data);
        setpolygonRender(resultinfo.data.poligono);
        
    })

    .catch((error) => console.log("error", error));
}, []);

return (
    <>
    <PolygonEdit
        data={polygon}
        dataRender={polygonRender}
        id={id.id}
        token={token}
    />
    </>
);
};


// ## Summary
// The `PolygonSearch` function is a React component that retrieves polygon data from an API and renders it using the `PolygonEdit` component.

// ## Example Usage
// ```javascript
// <PolygonSearch />
// ```

// ## Code Analysis
// ### Inputs
// - None
// ___
// ### Flow
// 1. The function retrieves the token from the session storage.
// 2. It gets the `id` parameter from the URL using the `useParams` hook.
// 3. It sets the `METOD0` variable to "GET" and constructs the API URL.
// 4. It initializes the `polygon` and `polygonRender` state variables using the `useState` hook.
// 5. The `useEffect` hook is used to fetch the polygon data from the API when the component mounts.
// 6. The fetched data is stored in the `polygon` and `polygonRender` state variables.
// 7. The `PolygonEdit` component is rendered with the fetched polygon data and other props.
// 8. The component returns the rendered `PolygonEdit` component.
// ___
// ### Outputs
// - The rendered `PolygonEdit` component with the fetched polygon data.
// ___
